import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import DashboardEmbed from "../models/DashboardEmbed";

export default (id: number) =>
  axiosApi.get<DashboardEmbed>(
    `${BackendServices.DASHBOARD_SERVICE.DASHBOARD}/${id}/embed`
  );
